import { render, staticRenderFns } from "./售后政策.vue?vue&type=template&id=664dfd48&scoped=true&"
import script from "./售后政策.vue?vue&type=script&lang=js&"
export * from "./售后政策.vue?vue&type=script&lang=js&"
import style0 from "./售后政策.vue?vue&type=style&index=0&id=664dfd48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664dfd48",
  null
  
)

export default component.exports